import { render, staticRenderFns } from "./DialogService.vue?vue&type=template&id=f3ead134&scoped=true"
import script from "./DialogService.vue?vue&type=script&lang=ts"
export * from "./DialogService.vue?vue&type=script&lang=ts"
import style0 from "./DialogService.vue?vue&type=style&index=0&id=f3ead134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ead134",
  null
  
)

export default component.exports